import { render, staticRenderFns } from "./MobileCoreIcon.vue?vue&type=template&id=ff264d52&"
import script from "./MobileCoreIcon.vue?vue&type=script&lang=js&"
export * from "./MobileCoreIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports